import React, { useEffect, useState } from "react";
import SideBar from "../components/SideBar";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import { useNavigate } from "react-router-dom";
import { highlightMatch } from "../variables/stringFunctions";
import { searchLotAttestation } from "../hooks/useSearch";


const SinglePageLayout = ({ children, currentMenu }) => {
    const [searchResults, setSearchResults] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    const navigate = useNavigate();

    const renderSearchResults = (results) => {
        return <div className="px-3 py-2">
            {results.map((item, index) => (
                <div
                    key={index}
                    onClick={() =>
                        navigate(`/dispatching-lot-attestation/${item.codeId}`)
                    }
                    className="dropdown-item d-flex align-items-center gap-2 py-1"
                    style={{ cursor: "pointer" }}
                >
                    <span className="text-truncate">
                        Lot d'{" "}
                        {[
                            item?.typeAttestation,
                            `[${item?.lot1} - ${item?.lot2}]`,
                            item?.compagnie,
                        ].map((text, i) => (
                            <React.Fragment key={i}>
                                {i > 0 && " - "}
                                {highlightMatch(text?.toString(), searchValue)}
                            </React.Fragment>
                        ))}
                    </span>
                </div>
            ))}
        </div>;
    }

    useEffect(() => {
        if (searchValue && searchValue?.length > 2) {
            searchLotAttestation(searchValue).then((res) => {
                setSearchResults(res.data);
            }).catch((err) => {
                console.log(err);
            });
        }
    }, [searchValue]);

    return (
        <div className="layout-wrapper layout-content-navbar  ">
            <div className="layout-container">
                <SideBar currentMenu={currentMenu} />
                {/* <!-- Layout container --> */}
                <div className="layout-page">
                    <NavBar
                        filteredResults={searchResults}
                        setFilteredResults={setSearchResults}
                        renderSearchResults={renderSearchResults}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                    />

                    {/* <!-- Content wrapper --> */}
                    <div className="content-wrapper">
                        {/* <!-- Content --> */}
                        <div className="container-xxl flex-grow-1 container-p-y">
                            {children}
                            {/* Your main content here */}
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div className="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div className="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div className="drag-target"></div>
        </div>
    );
};

export default SinglePageLayout;
